import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Routes } from '../../utils/constants/routes';

export function SearchResult({ hotSpot }) {
    const history = useHistory();
    const truncatedTitle = hotSpot.productName.split(' ').slice(0, 8).join(' ') + '...';
    const navigateToHotSpots = () => {
        const url = hotSpot.modelUrl;
        console.log('url:', url);
        const fsnId = hotSpot.fsn;
        console.log('fsnId:', fsnId);
        const hotspotObject = {
            modelUrl: hotSpot.modelUrl,
            routedActiveProductFSN: fsnId,
            fitIn3dModelUrl: hotSpot.fitIn3dModelUrl,
            defaultModelUrl: hotSpot.modelUrl
        };
        history.push(`${Routes.OPS_ROUTES.HOTSPOT.replace(':id', fsnId)}`, hotspotObject);
    };
    return (
        <div className="bg-white p-4 min-full rounded-sm shadow-md flex justify-between items-center mx-4">
            <div className=" flex items-center">
                <img src={hotSpot.primaryImage} className="py-2" alt={hotSpot.productName} height={50} width={50} />

                <div className=" truncate mb-2 mx-4 ">{truncatedTitle}</div>
            </div>
            {hotSpot.threedEnabled && (
                <button onClick={navigateToHotSpots} className="rounded-md bg-blue-600 cursor-pointer shadow-lg text-white py-2 px-4">
                    Edit Hotspots
                </button>
            )}
        </div>
    );
}

export default function SearchResultsList({ hotSpots }) {
    return (
        <ul className="w-full">
            {hotSpots.map((hotSpot) => (
                <li key={hotSpot.productName}>
                    <SearchResult hotSpot={hotSpot} />
                </li>
            ))}
        </ul>
    );
}
